import Button from 'global/react-mui/atoms/Button';
import React, { useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormStep, StepsState} from '../../../model/global';
import {stepsActions} from '../../../store/modules/steps/reducer';
import {currentStepSelector, formSummarySelector, stepsSelector} from '../../../store/modules/steps/selectors';
import {submitForm, validateStep} from '../../../store/modules/steps/thunks';
import {translationsSelector} from '../../../store/modules/translations/selectors';
import {Box, CircularProgress} from "@material-ui/core";

const FormStepsNav: React.FC<any> = () => {

    const dispatch = useDispatch()
    const {prevButtonText, nextButtonText, submitButtonText} = useSelector(translationsSelector)
    const {activeStepIndex, requestedStepIndex, steps, formSubmitError} = useSelector(stepsSelector)
    const [submitButtonShouldBeDisabled, setSubmitButtonShouldBeDisabled] = useState(false);
    const currentStep = useSelector(currentStepSelector) as FormStep
    const summary = useSelector(formSummarySelector) as StepsState['formSummary']

    // if last step, show submit button instead
    const isSubmit = activeStepIndex >= steps.length - 1;

    const goToStep = (direction: 'next' | 'prev') => {
        const newStep = direction === 'prev' ? activeStepIndex - 1 : activeStepIndex + 1


        if (newStep < 0) return
        dispatch(stepsActions.setRequestedStep(newStep))
        if (direction === 'prev') return

        const validationUrl = currentStep?.stepData.validation.url;
        if (validationUrl) {
            // console.log('call validation API here...', validationUrl)
            dispatch(validateStep())
        } else {
            // do this if no validation URL?
            //console.log("entered here")
            dispatch(stepsActions.declareStepValidity({stepTemplate: currentStep?.stepTemplate, validity: true}))
        }
    }

    const submitTheForm = () => {
        setSubmitButtonShouldBeDisabled(true);
        dispatch(submitForm())
    }


    useEffect(() => {
        // if going back, just go to step
        if (requestedStepIndex > -1 && requestedStepIndex < activeStepIndex) {
            dispatch(stepsActions.setActiveStep(requestedStepIndex))
            return;
        }

        const elem = document.getElementById('form-top')
        if (activeStepIndex > 0) {
            if (elem) setTimeout(() => elem.scrollIntoView({behavior: 'smooth', block: 'start'}), 400)
        }


    }, [activeStepIndex, dispatch, requestedStepIndex]);

    useEffect(() => {
        // if step is valid, go to step
        if (!currentStep || !currentStep.stepTemplate) return;
        if (summary.validatedSteps[currentStep.stepTemplate] === true || (currentStep.stepTemplate === 'FILE_ATTACHMENTS' && summary.validatedStepsHTML5[currentStep.stepTemplate])) {
            dispatch(stepsActions.setActiveStep(requestedStepIndex))
        }

    }, [currentStep, dispatch, requestedStepIndex, summary.validatedSteps, summary.validatedStepsHTML5])

    // allow users to click submit after 30 secs
    useEffect(() => {
        if (formSubmitError.length <= 0) return

        const result = setTimeout(function () {
            setSubmitButtonShouldBeDisabled(false);
            dispatch(stepsActions.setFormSubmitError(''))
        }, 30000);


        return () => clearTimeout(result);
    }, [formSubmitError])

    const getNextButtonDisabledState = () => {
        const isValid = summary.validatedStepsHTML5[currentStep.stepTemplate];
        return !isValid;
    }

    const getSubmitButtonDisabledState = () => {
        const isValid = summary.validatedStepsHTML5[currentStep.stepTemplate];
        return !isValid;
    }

    if (!currentStep) return null

    const disabled = isSubmit ? getSubmitButtonDisabledState() : getNextButtonDisabledState();
    const tabIndex = isSubmit ? -1 : 0
    const btnText = isSubmit ? submitButtonText : nextButtonText

    return (
        <div className={'nav-button-wrapper'}>
            <Button {
                        ...{
                            onClick: () => goToStep('prev'),
                            disabled: activeStepIndex === 0,
                            variant: "outlined",
                            size: "large",
                            className: "btn-step btn-prev"
                        }
                    }>
                {prevButtonText}
            </Button>

            <Button onClick={isSubmit ? e => submitTheForm() : e => goToStep('next')} {
                ...{
                    tabIndex,
                    disabled: (submitButtonShouldBeDisabled ? submitButtonShouldBeDisabled : disabled),
                    variant: "outlined",
                    size: "large",
                    className: "btn-step btn-next"
                }
            }>
                {(isSubmit && submitButtonShouldBeDisabled) ?  <CircularProgress size={'1.5rem'} /> : btnText}
            </Button>
        </div>
    );
};

export default FormStepsNav;